/* eslint-disable @typescript-eslint/no-explicit-any */

import { Value } from '@/types/getPendingPaymentsType';

import {
  ColumnFilterElementTemplateOptions,
  ColumnProps,
} from 'primereact/column';
import { TableDropdownFilter } from '@/components';
import { TableData } from '@/components/Table/types';
import DeletePendingPaymentsModal from '../DeletePendingPaymentsModal';
import { PendingPaymentsFiltersType } from '../PendingPaymentsFilters';

type StatusValues = {
  [key: string]: string;
};

const STATUS_COLORS: StatusValues = {
  'En Proceso': '#374f93',
  'En Edición': '#ffd389',
  'En Edici?n': '#ffd389',
  'Pendiente de Pago': '#fd8800',
  Agendada: '#4780bf',
  Paga: '#619b77',
  Solicitada: '#91c4fc',
  Validada: '#cbfcde',
  Rechazada: '#e24b39',
  Autorizada: '#7dd19d',
  defaultColor: '#ffd389',
};

export const STATUSES: StatusValues = {
  'En Edición': 'A pagar',
  'En Edici?n': 'A pagar',
  'Pendiente de Pago': 'Pendiente de Pago',
};

export const getTableColumns = (
  data: Value[] | undefined,
  t: (key: string) => string,
  filters: PendingPaymentsFiltersType,
  getData: any
): ColumnProps[] => [
  {
    field: 'selection',
    selectionMode: 'single',
    style: { width: '3rem' },
  },
  {
    field: 'oid',
    header: t('table.settlement'),
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'numeroSeleccion',
    header: t('table.selection'),
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'observaciones',
    header: t('table.reference'),
    filter: true,
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'totalAmount',
    header: t('table.amount'),
    filter: true,
    style: { textAlign: 'right' },
    body: (rowData: Value) => {
      const value = (rowData.totalAmount || 0).toLocaleString('es-UY', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      return <b>{value}</b>;
    },
    showFilterMenu: true,
    sortable: true,
  },
  {
    field: 'estadoParseado',
    header: t('table.status'),
    filter: true,
    showFilterMenu: true,
    sortable: true,
    filterElement: (options: ColumnFilterElementTemplateOptions) => (
      <TableDropdownFilter
        options={options}
        data={data as unknown as TableData}
        fieldName="estadoParseado"
      />
    ),
    body: (rowData: Value) => {
      const backgroundColor = STATUS_COLORS[rowData.estado];

      return (
        <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
          <div
            style={{
              backgroundColor,
              width: '10px',
              height: '10px',
              borderRadius: '100%',
            }}
          />
          <span>{rowData.estadoParseado}</span>
        </div>
      );
    },
  },
  {
    field: 'delete',
    style: { width: '3rem' },
    body: (rowData: Value) => {
      return (
        <div className="flex align-items-center justify-content-center">
          <DeletePendingPaymentsModal
            paymentsOids={[rowData.oid]}
            rowData={rowData}
            filters={filters}
            getData={getData}
          />
        </div>
      );
    },
  },
];
